const TestCode = Object.freeze({
  LONGEVITY_SCORE: 464,
  ALBUMIN: 0,
  ALP: 1,
  ALT: 2,
  ANION_GAP: 3,
  APO_B: 4,
  APO_E: 5,
  AST: 6,
  BASOPHILS: 7,
  BICARBONATE: 8,
  BMI: 9,
  BP_D: 10,
  BP_S: 11,
  BUN_CREATINE: 12,
  BUN: 13,
  CALCIUM: 14,
  CHLORIDE: 15,
  CREATININE: 16,
  CYSTATIN_C: 17,
  DIRECT_BILIRUBIN: 18,
  DIRECT_LDL: 19,
  EGFR: 20,
  EOSINOPHILS: 21,
  FACTOR_II: 22,
  FACTOR_V: 23,
  FERRITIN: 24,
  FREET4: 25,
  GLOBULIN: 26,
  GLUCOSE: 27,
  HBA1C: 28,
  HDL: 29,
  HEIGHT: 30,
  HEMATOCRIT: 31,
  HEMOGLOBIN: 32,
  HOMAIR: 33,
  HOMOCYSTEINE: 34,
  HS_CRP: 35,
  INSULIN: 36,
  LIPOPROTEIN_A: 37,
  LP_PLA2: 38,
  LYMPHOCYTES: 39,
  MAGNESIUM: 40,
  MCH: 41,
  MCHC: 42,
  MCV: 43,
  MONOCYTES: 44,
  MPV: 45,
  MTHFR: 46,
  NEUTROPHILS: 47,
  NON_HDL: 48,
  PLATELET: 49,
  POTASSIUM: 50,
  PTT_ACTIVATED: 51,
  PULSE: 52,
  RBC: 53,
  RDW: 54,
  SD_LDL: 55,
  SODIUM: 56,
  FREET3: 57,
  TOTALT3: 58,
  TOTALT4: 59,
  TC: 60,
  TG_HDL: 61,
  TG: 62,
  TOTAL_BILIRUBIN: 63,
  TOTAL_PROTEIN: 64,
  TSH: 65,
  URIC_ACID: 66,
  VITAMIN_D: 67,
  VLDL: 68,
  WAIST: 69,
  WBC: 70,
  WEIGHT: 71,
  NEUTROPHILS_PERCENTAGE: 72,
  LYMPHOCYTES_PERCENTAGE: 73,
  MONOCYTES_PERCENTAGE: 74,
  EOSINOPHILS_PERCENTAGE: 75,
  BASOPHILS_PERCENTAGE: 76,
  //MICROALBUMIN: 77,
  APO_A: 78,
  // IRON: 79,
  URINE_CREATININE: 80,
  // PT: 81,
  INR: 82,
  MYELOPEROXIDASE: 83,
  CPEPTIDE: 84,
  GLYCOMARK: 85,
  TROPONIN_T_HS: 86,
  ADIPONECTIN: 87,
  LEPTIN: 88,
  TOTAL_TESTOSTERONE: 89,
  FREE_TESTOSTERONE: 90,
  IGFI: 91,
  SHBG: 92,
  ANA_PATTERN: 93,
  ANA_SCREEN: 94,
  ANA_TITER: 95,
  PSA_TOTAL: 96,
  // PROTHROMBIN_TIME: 97,
  // PARTIAL_THROMBOPLASTIN_TIME_ACTIVATED: 99,
  URINALYSIS_URINE_COLOR: 100,
  URINALYSIS_URINE_APPEARANCE: 101,
  URINALYSIS_UROBILINOGEN: 102,
  URINALYSIS_PH: 103,
  URINALYSIS_LEUKOCYTES: 105,
  URINALYSIS_NITRITE: 106,
  URINALYSIS_PROTEIN: 107,
  URINALYSIS_OCCULT_BLOOD: 108,
  URINALYSIS_KETONE: 109,
  URINALYSIS_BILIRUBIN: 110,
  URINALYSIS_GLUCOSE: 111,
  VITAMIN_B12: 112,
  IRON_TOTAL: 113,
  GGT: 114,
  CREATINE_KINASE: 115,
  FOLATE: 116,
  BP: 117,
  ESTRADIOL: 118,
  GRIP: 119,
  LH: 121,
  FSH: 122,
  TESTOSTERONE_TOTAL: 123,
  GRIP_RIGHT: 124,
  GRIP_LEFT: 125,
  CAMPESTEROL: 126,
  SITOSTEROL: 127,
  LATHOSTEROL: 128,
  DESMOSTEROL: 129,
  REVERSE_T3: 130,
  THYROGLOBULIN_ANTIBODY: 131,
  TPO_ANTIBODY: 132,
  OMEGA_3_INDEX: 133,
  URINALYSIS_SPECIFIC_GRAVITY: 134,
  URINALYSIS_MICROSCOPIC_WBC: 135,
  URINALYSIS_MICROSCOPIC_RBC: 136, 
  URINALYSIS_MICROSCOPIC_SQUAMOUS_EPITHELIAL: 137,
  URINALYSIS_MICROSCOPIC_BACTERIA: 138,
  URINALYSIS_MICROSCOPIC_HYALINE_CAST: 139,
  T3_UPTAKE: 140,
  FREET4_INDEX: 142,
  TIBC: 143,
  IRON_SATURATION: 144,
  ALBUMIN_GLOBULIN: 145,
  IGA: 146,
  IGA_TTG: 147,
  HIV_AG_AB: 148,
  HIV_AB_DIFFERENTIATION: 149,
  BODY_FAT: 150,
  BODY_WATER: 151,
  BONE_MASS: 152,
  TRAILING_WEEK_SLEEP_HEART_RATE: 153,
  TRAILING_WEEK_SLEEP_HOURS: 154,
  TRAILING_WEEK_STEPS: 155,
  FREE_TESTOSTERONE_DIRECT: 156,
  LDL_CHOLESTEROL_NONFASTING: 157,
  TG_NONFASTING: 158,
  HEP_C_AB: 159,
  DHEA_S: 160,
  CORTISOL: 161,
  RBC_MAGNESIUM: 162,
  CRP: 163,
  MYELOPEROXIDASE_AB: 164,
  PROTEINASE3_AB: 165,
  TOTAL_IGE: 166,
  ALTERNARIA_ALTERNATA_MOLD_IGE: 167,
  ASPERGILUUS_FUMIGATUS_MOLD_IGE: 168,
  BERMUDA_GRASS_IGE: 169,
  BIRCH_TREE_IGE: 170,
  CAT_DANDER_IGE: 171,
  CLADOSPORIUM_HERBARUM_MOLD_IGE: 172,
  DOG_DANDER_IGE: 173,
  DUST_MITE_DF_IGE: 174,
  DUST_MITE_DP_IGE: 175,
  ELM_TREE_IGE: 176,
  JOHNSON_GRASS_IGE: 177,
  LAMBS_QUARTERS_WEED_IGE: 178,
  MOUNTAIN_CEDAR_TREE_IGE: 179,
  MUGWORT_WEED_IGE: 180,
  OAK_TREE_IGE: 181,
  OLIVE_TREE_IGE: 182,
  RYEGRASS_IGE: 183,
  WALNUT_TREE_POLLEN_IGE: 184,
  WESTERN_RAGWEED_IGE: 185,
  IMMATURE_GRANULOCYTE_COUNT: 186,
  URINE_CULTURE_RESULT: 187,
  NEISSERIA_GONORRHOEAE_RNA: 188,
  CHLAMYDIA_RNA: 189,
  COVID19_RNA: 190,
  SKIN_BIOPSY_RIGHT_ABDOMEN: 191,
  SKIN_BIOPSY_MID_ABDOMEN: 192,
  SKIN_BIOPSY_LEFT_CHEST: 193,
  SKIN_BIOPSY_LEFT_UPPER_CHEST: 194,
  DEXA_TOTAL_BODY_FAT: 195,
  DEXA_VAT_MASS: 196,
  DEXA_TOTAL_LEAN_MASS: 197,
  DEXA_LEAN_MASS_ARMS: 198,
  DEXA_LEAN_MASS_LEGS: 199,
  DEXA_ALMI: 200,
  DEXA_FFMI: 201,
  TRANSFERRIN: 202,
  VITAMIN_B6: 203,
  SICKLE_CELL_SCREEN: 204,
  CORTISOL_PM: 205,
  PROGESTERONE: 206,
  TOTAL_HCG: 207,
  DDIMER: 208,
  PROLACTIN: 209,
  UIBC: 210,
  INDIRECT_BILIRUBIN: 211,
  CHOLESTANOL: 212,
  CHOLESTEROL_BALANCE_SCORE: 213,
  HEMOGLOBIN_A: 214,
  HEMOGLOBIN_A2: 215,
  HEMOGLOBIN_F: 216,
  PSA_FREE: 217,
  PSA_FREE_RATIO: 218,
  LDL_CHOLESTEROL_CALC: 219,
  IGA_DGP: 220,
  STREPTOCOCCUS_A_DNA: 221,
  EBV_CAPSID_IGM: 222,
  EBV_NUCLEAR_IGG: 223,
  EVB_VCA_IGG: 224,
  DNAM_PHENOAGE: 225,
  ANA_IGG: 226, 
  ESR: 227,
  COMPLEMENT_C3: 228,
  DOUBLE_STRAND_DNA_AB: 229,
  HEP_B_S_AG: 230,
  DHT: 231,
  ZINC: 232,
  PREGNENOLONE: 233,
  LDL_PARTICLE_NUMBER: 234,
  LDL_SMALL: 235,
  LDL_MEDIUM: 236,
  LDL_PEAK_SIZE: 237,
  LDL_PATTERN: 238,
  HDL_LARGE: 239,
  PHOSPHOROUS: 240,
  COMPLEMENT_C4: 241,
  HSV2_IGG_INHIBITION: 242,
  HSV2_PERCENT_INHIBITION: 243,
  HSV2_INHIBITION_INTERPRETATION: 244,
  OMEGA_6_3: 245,
  EPA: 246,
  DHA: 247,
  ARACHIDONIC: 248,
  ARACHIDONIC_EPA: 249,
  IGG_TTG: 250,
  IGG_DGP: 251,
  DUST_MITE_DM_IGE: 252,
  MAPLE_TREE_IGE: 253,
  TIMOTHY_GRASS_IGE: 254,
  CULTIVATED_OAT_GRASS_IGE: 255,
  ROUGH_PIGWEED_IGE: 256,
  SCALE_IGE: 257,
  BUCKWHEAT_IGE: 258,
  CORN_IGE: 259,
  OAT_IGE: 260,
  RICE_IGE: 261,
  SEASAME_IGE: 262,
  SOYBEAN_IGE: 263,
  WHEAT_IGE: 264,
  EGG_WHITE_IGE: 265,
  COWS_MILK_IGE: 266,
  ALMOND_IGE: 267,
  BRAZIL_NUT_IGE: 268,
  COCONUT_IGE: 269,
  HAZELNUT_IGE: 270,
  PEANUT_IGE: 271,
  BLUE_MUSSEL_IGE: 272,
  CODFISH_IGE: 273,
  SALMON_IGE: 274,
  SHRIMP_IGE: 275,
  TUNA_IGE: 276,
  CANDIDA_ALBICANS_MOLD_IGE: 277,
  CURVULARIA_LUNATA_MOLD_IGE: 278,
  EPICOCCUM_PURPURASCENS_MOLD_IGE: 279, 
  FUSARIUM_MONILIFORME_MOLD_IGE: 280,
  HELMINTHOSPORIUM_HALODES_MOLD_IGE: 281,
  MUCOR_RACEMOSUS_MOLD_IGE: 282,
  PENICILLIUM_NOTATUM_MOLD_IGE: 283,
  PHOMA_BETAE_MOLD_IGE: 284,
  PITYROSPORUM_ORBICULARE_MOLD_IGE: 285,
  RHIZOPUS_NIGRICANS_MOLD_IGE: 286,
  STEMPHYLIUM_BOTRYOSUM_MOLD_IGE: 287,
  TRICHODERMA_VIRIDE_MOLD_IGE: 288,
  URINE_COTININE: 289,
  URINE_PROTEIN_QUANTITATIVE: 290,
  URINE_GLUCOSE_QUANTITATIVE: 291,
  URINALYSIS_MICROSCOPIC_CRYSTALS: 292,
  URINALYSIS_MICROSCOPIC_WBC_QUANTITATIVE: 293,
  URINALYSIS_MICROSCOPIC_RBC_QUANTITATIVE: 294,
  PROTEIN_ELECTRO_TOTAL_PROTEIN: 295,
  PROTEIN_ELECTRO_ALBUMIN: 296,
  PROTEIN_ELECTRO_ALPHA1: 297,
  PROTEIN_ELECTRO_ALPHA2: 298,
  PROTEIN_ELECTRO_BETA1: 299,
  PROTEIN_ELECTRO_BETA2: 300,
  PROTEIN_ELECTRO_GAMMA: 301,
  GALLERI: 302,
  DUNEDINPACE: 303,
  HEP_B_S_AG_QUANT: 304,
  ANTI_HAV_IGM: 305,
  ANTI_HBC_IGM: 306,
  RHEUMATOID_FACTOR: 307,
  FIBRINOGEN: 308,
  VITAMIN_B1: 309,
  VITAMIN_B2: 310,
  PTH: 311,
  AFP: 312,
  MERCURY: 313,
  HSV1_IGG_TYPESPECIFIC_AB: 314,
  HSV2_IGG_TYPESPECIFIC_AB: 315,
  TRICHOMONAS_VAGINALIS: 316,
  RPR: 317,
  URINE_ALBUMIN: 318,
  UACR: 319,
  LIPASE: 321,
  MMA: 322,
  LEAD: 323,
  IODINE: 324,
  COPPER: 325,
  SELENIUM: 326,
  ALUMINUM: 327,
  ARSENIC: 328,
  LYME_DISEASE_AB: 329,
  TRANSFAT_INDEX: 330,
  AMH: 331,
  NMR_LDL_P: 332,
  NMR_HDL_P: 333,
  NMR_SMALL_LDL_P: 334,
  NMR_LDL_SIZE: 335,
  NMR_LARGE_VLDL_P: 336,
  NMR_LARGE_HDL_P: 337,
  NMR_HDL_SIZE: 338,
  NMR_LP_IR_SCORE: 339,
  COMPLEMENT_TOTAL: 340,
  CHROMATIN_AB: 341,
  RNP_AB: 342,
  SM_AB: 343,
  SS_A_AB: 344,
  SS_B_AB: 345,
  CCP_AB: 346,
  PRO_BNP: 347,
  TROPININ_I_HS: 348,
  NMR_VLDL_SIZE: 349,
  FRUCTOSAMINE: 350,
  RHEUMATOID_FACTOR_IGA: 351,
  T_PALLIDUM_AB_EIA: 352,
  NEISSERIA_GONORRHOEAE_NAA: 353,
  CHLAMYDIA_TRACHOMATIS_NAA: 354,
  DEXA_BMD_Z_SCORE: 355,
  DEXA_BMD_T_SCORE: 356,
  CAC: 357,
  TGI: 358,
  VLDL_DIRECT: 359,
  PAHI: 360,
  PRDI: 361,
  ODI: 362,
  TST: 363,
  REM_SLEEP: 364,
  DEEP_SLEEP: 365,
  SLEEP_LATENCY: 366,
  IL6: 367,
  SLEEP_EFFICIENCY: 368,
  SLEEP_PULSE_RATE: 369,
  TOTAL_IGG: 370,
  LDH: 371,
  AMYLASE: 372,
  VITAMIN_D_1_25: 373,
  ABO_GROUP: 374,
  RH_TYPE: 375,
  VO2_MAX: 376,
  CAC_LM: 377,
  CAC_LAD: 378,
  CAC_CIRCUMFLEX: 379,
  CAC_RCA: 380,
  CCTA_TOTAL_PLAQUE: 381,
  CCTA_TOTAL_NONCALCIFIED_PLAQUE: 382,
  CCTA_TOTAL_CALCIFIED_PLAQUE: 383,
  CCTA_TOTAL_PAV: 384,
  MAX_NARROWING_RCA: 385,
  MAX_NARROWING_LM: 386,
  MAX_NARROWING_LAD: 387,
  MAX_NARROWING_CIRCUMFLEX: 388,
  MYCOTOX_AFM1: 389,
  MYCOTOX_OTA: 390,
  MYCOTOX_ROE: 391,
  MYCOTOX_VRA: 392, 
  MYCOTOX_ZEA: 393,
  MYCOTOX_CHA: 394,  
  MYCOTOX_DHC: 395,
  MYCOTOX_ENB: 396,
  MYCOTOX_GTX: 397,
  MYCOTOX_MPA: 398,
  MYCOTOX_STC: 399,
  FECAL_OCCULT: 400,
  DEXA_BMD_LUMBAR_T_SCORE: 401,
  DEXA_BMD_LUMBAR_Z_SCORE: 402,
  DEXA_BMD_LEFT_HIP_T_SCORE: 403,
  DEXA_BMD_LEFT_HIP_Z_SCORE: 404,
  DEXA_BMD_FEMORAL_NECK_T_SCORE: 407,
  DEXA_BMD_FEMORAL_NECK_Z_SCORE: 408,
  CALCIUM_IONIZED: 409,
  CK_BB: 410,
  CK_MB: 411,
  CK_MM: 412,
  ECG_VENTRICULAR_RATE: 413,
  ECG_ATRIAL_RATE: 414,
  ECG_PR_INTERVAL: 415,
  ECG_QT_INTERVAL: 416,
  ECG_QTC_INTERVAL: 417,
  ECG_QRS_DURATION: 418,
  ECG_P_AXIS: 419,
  ECG_R_WAVE_AXIS: 420,
  ECG_T_WAVE_AXIS: 421,
  STRESS_TEST_MAX_BP_D: 422,
  STRESS_TEST_MAX_BP_S: 423,
  STRESS_TEST_MAX_HR: 424,
  STRESS_TEST_PEAK_METS: 425,
  STRESS_TEST_PEAK_HR: 426,
  STRESS_TEST_PEAK_BP_D: 427,
  STRESS_TEST_PEAK_BP_S: 428,
  HTLV_I_II_ANTIBODY: 429,  
  MEASLES_AB_IGG: 430,
  MUMPS_VIRUS_IGG: 431,
  RUBELLA_AB_IGG: 432,
  VARICELLA_ZOSTER_VIRUS_AB_IGG: 433,
  VARICELLA_ZOSTER_VIRUS_AB_IGM: 434,
  RBC_ANTIBODY_SCREEN: 435,
  CAC_PDA: 436, 
  UREA: 437,
  CAMPESTEROL_NORMALIZED: 438,
  SITOSTEROL_NORMALIZED: 439,
  LATHOSTEROL_NORMALIZED: 440,
  DESMOSTEROL_NORMALIZED: 441,
  HUMAN_GROWTH_HORMONE: 442,
  PROTHROMBIN_TIME: 97,
  AMMONIA: 79,
  PANCREATIC_AMYLASE: 81,
  MITOCHONDRIA_M2_ANTIBODY_IGG: 99,
  DIURETIC_SCREEN_URINE: 320,
  SPERM_VOLUME: 443,
  SPERM_COUNT: 444,
  SPERM_MOTILE_COUNT: 445,
  SPERM_CONCENTRATION: 446,
  SPERM_MOTILITY: 447,
  SPERM_MORPHOLOGY: 448,
  URINE_HEMOGLOBIN: 449,
  SERUM_HIV: 450,
  MYOGLOBIN_SERUM: 451,
  LYME_DISEASE_AB_IGM: 452,
  NICKEL: 453,
  CADMIUM: 454,
  OX_LDL: 455,
  HERPES_SIMPLEX_IGG: 456,
  GLUTATHIONE: 457,
  ESTRADIOL_US: 458,
  CTX: 459,
  RMR: 460,
  SALIVARY_AMYLASE: 461,
  EMA_IGA: 462,
  RETICULIN_IGA: 463,
  DPA: 465,
  LINOLEIC_ACID: 466,
  OMEGACHECK: 467,
  CA_125: 468,  
  BRACA1: 469,
  BRACA2: 470,
  DEOXYCORTISOL: 471,
  CORTISONE: 472,
  HYDROXYCORTICOSTERONE: 473,
  DEOXYCORTICOSTERONE: 474,
  ACTH_PLASMA: 475,
  HYDROXYPROGESTERONE: 476,
  ANDROSTENEDIONE: 477,
  DHEA_UNCONJUGATED: 478,
  HYDROXYPREGNENOLONE: 479,
  CORTICOSTERONE: 480,
  ESTRONE: 481,
  FREE_TESTOSTERONE_DIALYSIS: 482,
  IGM: 483,
  CD3_PCT: 484,
  CD3_ABS: 485,
  CD4_PCT: 486,
  CD4_ABS: 487,
  CD8_PCT: 488,
  CD8_ABS: 489,
  CD4_CD8_RATIO: 490,
  NK_PCT: 491,
  NK_ABS: 492,
  C1Q_BINDING:493,
  TSI: 494,
  INTACT_INSULIN: 495,
  CARDIOIQ_IR_SCORE: 496,
  APC: 497,
  CD8_HLA_ABS: 498,
  CD8_HLA_PCT: 499,
  CD3_CD25_PCT:500,
  CD3_CD25_ABS:501,
  CD8_CD38_PCT:502,
  CD8_CD38_ABS:503,
  VITAMIN_B7: 504,  
  VITAMIN_A: 505,
  VITAMIN_B3: 506,
  VITAMIN_B5: 507,
  VITAMIN_C: 508,
  VITAMIN_E_ALPHA: 509,
  VITAMIN_E_BETA_GAMMA: 510,
  VITAMIN_K1: 511,
  AALP_APOC1: 512,
  AALP_APOC2: 513,
  AALP_APOC3: 514,
  AALP_APOC4: 515,
  HDLFX_PCAD: 516,
  CHROMIUM: 517,  
  COBALT: 518,
  THALLIUM: 519,
  CERULOPLASMIN: 520,
  MANGANESE: 521,
  ALDOSTERONE: 522,
  RENIN_ACTIVITY: 523,
  RHEUMATOID_FACTOR_IGM: 524,
  RHEUMATOID_FACTOR_IGG: 525,
  TMAO: 526, 
  IGG1: 527,  
  IGG2: 528,
  IGG3: 529,
  IGG4: 530,
  MMP9: 531,
  OSMOLALITY: 532,
  COMPLEMENT_C4A: 533,
  PAI1: 534,
  AFP_L3: 535,
  LDH_1: 536,
  LDH_2: 537,
  LDH_3: 538,
  LDH_4: 539, 
  LDH_5: 540,
  ESTRIOL: 541,
  ESTROGEN: 542,
  GASTRIN: 543,
  CA_153: 544,
  CA_199: 545,
  CEA: 546,
  GLUTEN_IGE: 547,
  WHEY_IGE: 548,
  ALP_INTESTINAL: 549,
  ALP_BONE: 550,
  ALP_LIVER: 551,
  ALP_PLACENTAL: 552,
  ALP_MACROHEPATIC: 553,
  EBV_CAPSID_IGG: 554,
  RBC_ANTIBODY_TITER: 555,
  RBC_ANTIBODY_ID: 556, 
  ANCA_SCREEN: 557,
  CANCA_TITER: 558,
  PANCA_TITER: 559,
  ATYPICAL_PANCA_TITER: 560,
  JO1_ANTIBODY: 561,
  SCLERODERMA_ANTIBODY: 562,
  CENTROMERE_B_AB: 563,
  CARDIOLIPIN_IGG: 564, 
  CARDIOLIPIN_IGM: 565,
  CARDIOLIPIN_IGA: 566,
  BETA_2_GLYCOPROTEIN_I_IGG: 567,
  BETA_2_GLYCOPROTEIN_I_IGA: 568,
  BETA_2_GLYCOPROTEIN_I_IGM: 569,
  MCV_ANTIBODY: 570,
  COQ10: 571,
  VEGF: 572,
  P_TAU217: 573,
  AMYLOID_BETA_42: 574,
  AMYLOID_BETA_40: 575,
  AMYLOID_BETA_42_40_RATIO: 576,
  FIBROTEST_SCORE: 577,
  ACTITEST_SCORE: 578,
  ALPHA_2_MACROGLOBULIN: 579,
  HAPTOGLOBIN: 580,
  ADMA: 581,
  SMDA: 582,
  SEROTONIN: 583,
  CARNITINE: 584,
  MONO_SCREEN: 585,
  ALPHA_GAL_IGE: 586,
  ZPP: 587,
  ANTIADRENAL_ANTIBODY_SCREEN: 588,
  PREALBUMIN: 589,
  MELATONIN: 590,
  TNF_ALPHA: 591,
  RETICULOCYTE_COUNT: 592,
  ERYTHROPOIETIN: 593,
  P1NP: 594,
  BORON: 595,
  SCALLOP_IGE: 596,
  CASHEW_IGE: 597,
  WALNUT_IGE: 598,
  CHOLESTEROL_EFFLUX: 599,
  URINALYSIS_MICROSCOPIC_TRANSITIONAL_EPITHELIAL: 600,
  URINALYSIS_MICROSCOPIC_RENAL_EPITHELIAL: 601,
  URINALYSIS_MICROSCOPIC_CALCIUM_OXALATE: 602,
  URINALYSIS_MICROSCOPIC_TRIPLE_PHOSPHATE: 603,
  URINALYSIS_MICROSCOPIC_URIC_ACID: 604,
  URINALYSIS_MICROSCOPIC_AMOURPHOUS_SEDIMENT: 605,
  URINALYSIS_MICROSCOPIC_GRANULAR_CASTS: 606,
  URINALYSIS_MICROSCOPIC_CASTS: 607,
  URINALYSIS_MICROSCOPIC_YEAST: 608,
  OGTT_GLUCOSE_1_HOUR: 609,
  OGTT_GLUCOSE_2_HOURS: 610,
  BP_D_24HR: 611,
  BP_S_24HR: 612,
  BPM_24HR: 613,
})

export default TestCode